var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExclamation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6.05,
    cy: 6.05,
    r: 4.95,
    fill: "#F0C8C8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    stroke: "#000",
    strokeWidth: 0.2,
    d: "M9.91 5.178c-.002.987-.309 1.946-.88 2.751-.544.765-1.329 1.369-2.209 1.69-.94.342-1.973.386-2.937.115-.926-.261-1.754-.81-2.368-1.55-.61-.735-.987-1.668-1.06-2.619-.077-.99.153-1.983.666-2.834.495-.82 1.238-1.473 2.11-1.871C4.12.453 5.149.342 6.107.535c.949.192 1.82.67 2.49 1.369.672.698 1.112 1.596 1.263 2.554.035.238.05.48.05.72 0 .286.443.286.443 0-.002-1.063-.33-2.118-.949-2.987C8.794 1.335 7.94.679 6.952.314 5.939-.06 4.804-.1 3.767.194c-1 .283-1.91.874-2.572 1.676C.514 2.695.1 3.708.016 4.776-.07 5.844.19 6.932.742 7.85c.535.884 1.338 1.61 2.28 2.036.997.451 2.114.58 3.187.367 1.028-.205 1.985-.738 2.709-1.495.723-.756 1.214-1.733 1.37-2.768.04-.268.065-.537.065-.81 0-.287-.442-.287-.442-.002z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.576 1.9)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.516,
    cy: 6.044,
    r: 1,
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.85,
    d: "M0.503 0.494L0.503 4.294"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamation);
export default __webpack_public_path__ + "static/media/Exclamation.41622ec4216826a968ab4a6c8daaaab9.svg";
export { ForwardRef as ReactComponent };